import { Box, TextField, Typography, Button } from "@mui/material"
import { DropzoneWrapper } from "./DropZoneWrapper"
import { useState, useEffect } from "react"

export const Setup = ({products, setOpen, setProducts, info, setInfo, snackBarLoader, setSnackBarLoader})=>{

    const [item, setItem] = useState({
        name: "",
        price: 0,
        quantity: 1,
        uom: 'pc',
    })

    const [preview, setPreview] = useState(null)

    const handleChange = (e, type)=>{
        e.preventDefault()
        if(type === "branch_name"){
            setInfo((prev)=>({...prev, [type]: e.target.value}))
            return
        }
        setItem((prev)=>({...prev, [type]: e.target.value}))
    }

    const handleAddProduct = ()=>{

        if(products.length === 5){
            setOpen(true)
            return
        }

        if (item.name === '') {
            setSnackBarLoader({...snackBarLoader, snackbar:true, msg: `Add Product Name!`, type: 'error'})
            return
        } else if (item.price === 0) {
            setSnackBarLoader({...snackBarLoader, snackbar:true, msg: `Invalid Price`, type: 'error'})
            return
        }

        setProducts((products) => [...products, item])
    }

    useEffect(() => {
        setItem({        
            name: "",
            price: 0,
            quantity: 1,
            uom: 'pc'
        })
        setPreview(null)
    }, [products]);


    return(
        <Box sx={{p: 3, display: "flex", flexDirection: "column", gap: 2, justifyContent: "space-between", height: "100%"}}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2, border: 1, borderRadius: 3, borderColor: "#B5BBC1"}}>
                <Typography sx={{fontWeight: 600}}>Store / Branch Information:</Typography>
                <Box>
                    <Typography sx={{fontWeight: 600}}>What's your store or branch name?</Typography>
                    <TextField value={info.branch_name} onChange={(e)=>{handleChange(e, 'branch_name')}} placeholder="Store or Branch Name" fullWidth/>
                </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2, border: 1, borderRadius: 3, borderColor: "#B5BBC1", height: "100%"}}>
                <Typography sx={{fontWeight: 600}}>Product Information:</Typography>
                <Box>
                    <Typography sx={{fontWeight: 600}}>Product Name:</Typography>
                    <TextField value={item.name} onChange={(e)=>{handleChange(e, 'name')}} placeholder="Product Name" fullWidth/>
                </Box>
                <Box>
                    <Typography sx={{fontWeight: 600}}>Product Price:</Typography>
                    <TextField value={item.price} onChange={(e)=>{handleChange(e, 'price')}} placeholder="Price" fullWidth/>
                </Box>
                <Box>
                    <Typography sx={{fontWeight: 600}}>Product Quantity:</Typography>
                    <TextField value={item.quantity} onChange={(e)=>{handleChange(e, 'quantity')}} placeholder="Quantity" fullWidth/>
                </Box>
                <Box>
                    <Typography sx={{fontWeight: 600}}>Unit of Measure:</Typography>
                    <TextField value={item.uom} onChange={(e)=>{handleChange(e, 'uom')}} placeholder="Unit of Measure" fullWidth/>
                </Box>
                <Box>
                    <Typography sx={{fontWeight: 600}}>Product Image:</Typography>
                    <DropzoneWrapper setItem={setItem} preview={preview} setPreview={setPreview}/>
                </Box>
                <Button onClick={handleAddProduct} fullWidth variant="contained" sx={{p: 2, boxShadow: "none", borderRadius: 2}}>Add Product</Button>  
            </Box>
        </Box>
    )
}